import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent implements OnInit {
  forgot: FormGroup;
  datas;
  private forgotPassword = environment.url + environment.forgotSave;
  /**
   * Construct a new ForgetPasswordComponent.
   * @param data The data that has been passed from the parent component.
   * @param fb The form builder service.
   * @param makeapi The API service.
   * @param getdata The value service.
   * @param notify The notification service.
   * @param dialogRef The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<ForgetPasswordComponent>
  ) {
    /**
     * The form group for the forget password form.
     * Contains the email field, which is required and must be a valid email address.
     */
    this.forgot = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {}
  get add() {
    return this.forgot.controls;
  }
  /**
   * Submits the forget password form.
   * If the form is invalid, shows an error message.
   * If the form is valid, sends the form data to the API and handles the response.
   */
  saveBtn() {
    if (this.forgot.invalid) {
      this.forgot.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      let getForm = this.forgot.value;
      this.makeapi
        .method(this.forgotPassword, getForm, 'login')
        .subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus == 'Success') {
            this.notify.notifysuccess(data.responseMessage);
            document.getElementById('reSubmitModal').style.display = 'block';
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Closes the forget password dialog.
   * Hides the re-submit modal and closes the dialog.
   */
  closeModal() {
    // Close the dialog
    this.dialogRef.close();

    // Hide the re-submit modal
    document.getElementById('reSubmitModal').style.display = 'none';
  }
  /**
   * Cancels the forget password operation.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    // Reset the form fields
    this.forgot.reset();

    // Close the dialog
    this.dialogRef.close();
  }
}
